import React from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"
import Link from "components/Link"
import { ReactComponent as Icon } from "images/navPlus.svg"

const SidebarLinks = ({ label, links }) => (
  <div
    css={{
      background: theme.white,
      borderBottom: `6px solid ${theme.midBlue}`,
      margin: "0 auto 40px",
      maxWidth: 360,
      padding: "28px 22px 8px",
      [theme.tabletSmall]: {
        marginBottom: 30,
        padding: "22px 15x 8px",
      },
    }}
  >
    <div
      css={{
        ...theme.t5lg,
        color: theme.midBlue,
      }}
    >
      {label}
    </div>

    <ul css={{ padding: 0, margin: "12px 0 0", listStyle: "none" }}>
      {links.map(({ text, href }, index) => (
        <li
          key={index}
          css={{
            margin: 0,
            padding: 0,
            "& + &": { borderTop: `1px solid ${theme.lightGray}` },
          }}
        >
          <Link
            href={href}
            css={theme.expandQueries({
              display: "flex",
              alignItems: "start",
              justifyContent: "space-between",
              padding: ["16px 0", "14px 0", "12px 0"],
              fontSize: [16, 13],
              fontWeight: 500,
              color: theme.gray,
              lineHeight: 1.5,
              ":hover": {
                color: theme.midBlue,
                textDecoration: "underline",
              },
            })}
          >
            {text}
            <Icon
              css={{
                flex: "0 0 14px",
                display: "block",
                width: 14,
                height: 14,
                marginLeft: 10,
                marginTop: 4,
                [theme.tabletSmall]: { display: "none" },
                [theme.mobile]: { display: "block" },
              }}
            />
          </Link>
        </li>
      ))}
    </ul>
  </div>
)

export default SidebarLinks

SidebarLinks.propTypes = {
  label: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
}
